<template>
  <b-form @submit.prevent="insertBridgeInfo">
    <b-card class="border0" body-class="grpHd anal">
      <div style="margin-top: 20px">FFT AVG 분석</div>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ fftavgPeakCntTitle }}</label>
          <b-form-input v-model="fftavgPeakCnt"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ fftavgFreqRangeTitle }}</label>
          <b-form-input
            style="width: 70px"
            v-model="fftavgFreqRangeStart"
          ></b-form-input
          >~
          <b-form-input
            style="width: 70px; margin-left: 10px"
            v-model="fftavgFreqRangeEnd"
          ></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ fftavgClusterCntTitle }}</label>
          <b-form-input v-model="fftavgClusterCnt"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ fftavgNumOfDataTitle }}</label>
          <b-form-select
            v-model="fftavgNumOfData"
            :options="fftavgNumOfDataOptions"
          ></b-form-select>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ fftavgOverlapTitle }}</label>
          <b-form-input v-model="fftavgOverlap"></b-form-input>
        </b-col>
      </b-row>

      <div style="margin-top: 20px">SSI 분석</div>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiFsTitle }}</label>
          <b-form-input v-model="ssiFs"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiTargetFreqNumTitle }}</label>
          <b-form-input v-model="ssiTargetFreqNum"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiOrderTitle }}</label>
          <b-form-input v-model="ssiOrder"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiXTitle }}</label>
          <b-form-input v-model="ssiX"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiAxisTitle }}</label>
          <b-form-select
            v-model="ssiAxis"
            :options="ssiAxisOptions"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiFreUpperBndTitle }}</label>
          <b-form-input v-model="ssiFreUpperBnd"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiFreLowerBndTitle }}</label>
          <b-form-input v-model="ssiFreLowerBnd"></b-form-input>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiFsTitle }}</label>
          <b-form-input v-model="ssiFs"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiMaxrowTitle }}</label>
          <b-form-input v-model="ssiMaxrow"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiStablevelTitle }}</label>
          <b-form-input v-model="ssiStablevel"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiOrdersTitle }}</label>
          <b-form-input v-model="ssiOrders"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiStabfreqTitle }}</label>
          <b-form-input v-model="ssiStabfreq"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiDampingTitle }}</label>
          <b-form-input v-model="ssiDamping"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiMacTitle }}</label>
          <b-form-input v-model="ssiMac"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiModescaleTitle }}</label>
          <b-form-input v-model="ssiModescale"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiProbthrTitle }}</label>
          <b-form-input v-model="ssiProbthr"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiScalingxiTitle }}</label>
          <b-form-input v-model="ssiScalingxi"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiScalingmacTitle }}</label>
          <b-form-input v-model="ssiScalingmac"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiOmeganTitle }}</label>
          <b-form-input v-model="ssiOmegan"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ ssiFreqRangeTitle }}</label>
          <b-form-input
            style="width: 70px"
            v-model="ssiFreqRangeStart"
          ></b-form-input
          >~
          <b-form-input
            style="width: 70px; margin-left: 10px"
            v-model="ssiFreqRangeEnd"
          ></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ ssiClusterCntTitle }}</label>
          <b-form-input v-model="ssiClusterCnt"></b-form-input>
        </b-col>
      </b-row> -->

      <!-- <div>IF 분석</div>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ rmfTitle }}</label>
          <b-form-input v-model="rmf"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ rmfMmTitle }}</label>
          <b-form-input v-model="rmfMm"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ slTitle }}</label>
          <b-form-input v-model="sl"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{ rdTitle }}</label>
          <b-form-input v-model="rd"></b-form-input>
        </b-col>
        <b-col class="col-4">
          <label class="head">{{ rdMmTitle }}</label>
          <b-form-input v-model="rdMm"></b-form-input>
        </b-col>
      </b-row> -->

      <!-- <div style="margin-top: 20px">Clustering 분석</div>
      <b-row>
        <b-col class="col-4">
          <label class="head">{{clusteringCntTitle}}</label>
          <b-form-input v-model="clusteringCnt"></b-form-input>
        </b-col>
      </b-row> -->
    </b-card>
    <div class="btnGrp">
      <div class="jcse">
        <b-button class="empty-searchBtn" @click="refreshData"
          ><i class="fa fa-search"></i>조회</b-button
        >
        <b-button class="empty-modBtn" type="submit"
          ><i class="fa fa-edit"></i>변경</b-button
        >
        <b-button class="empty-delBtn mr0" @click="closeModal"
          ><i class="fa fa-window-close"></i>닫기</b-button
        >
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["getUserId", "getAlertOptions", "getConfirmOptions"]),
  },
  props: {
    stid: {
      type: String,
      required: true,
    },
    bridgeData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fftavgPeakCnt: null,
      fftavgFreqRangeStart: null,
      fftavgFreqRangeEnd: null,
      fftavgClusterCnt: null,
      fftavgNumOfData: null,
      fftavgNumOfDataOptions: [
        { value: null, text: "선택" },
        { value: 1024, text: "1024" },
        { value: 2048, text: "2048" },
        { value: 4096, text: "4096" },
        { value: 8192, text: "8192" },
        { value: 16384, text: "16384" },
        { value: 32768, text: "32768" },
      ],
      fftavgOverlap: null,

      ssiFs: null,
      ssiMaxrow: null,
      ssiStablevel: null,
      ssiOrder: null,
      ssiOrders: null,
      ssiStabfreq: null,
      ssiDamping: null,
      ssiMac: null,
      ssiModescale: null,
      ssiProbthr: null,
      ssiScalingxi: null,
      ssiScalingmac: null,
      ssiOmegan: null,
      ssiTargetFreqNum: null,
      ssiX: null,
      ssiAxis: null,
      ssiAxisOptions: [
        { value: 0, text: "X" },
        { value: 1, text: "Y" },
        { value: 2, text: "Z" },
      ],
      ssiFreUpperBnd: null,
      ssiFreLowerBnd: null,

      ssiFreqRangeStart: null,
      ssiFreqRangeEnd: null,
      ssiClusterCnt: null,

      rd: null,
      rdMm: null,
      rmf: null,
      rmfMm: null,
      sl: null,

      clusteringCnt: null,

      fftavgPeakCntTitle: "Peak Cnt",
      fftavgFreqRangeTitle: "Freq Range",
      fftavgClusterCntTitle: "Clustering Cnt",
      fftavgNumOfDataTitle: "num of data",
      fftavgOverlapTitle: "overlap(%)",

      ssiFsTitle: "FS",
      ssiMaxrowTitle: "max row",
      ssiStablevelTitle: "stab. level",
      ssiOrderTitle: "SSI_Order",
      ssiOrdersTitle: "orders",
      ssiStabfreqTitle: "stab. freq",
      ssiDampingTitle: "damping",
      ssiMacTitle: "mac",
      ssiModescaleTitle: "mode scale",
      ssiProbthrTitle: "prob thr",
      ssiScalingxiTitle: "scaling xi",
      ssiScalingmacTitle: "scaling mac",
      ssiOmeganTitle: "scaling omega_n",
      ssiFreqRangeTitle: "Freq Range",
      ssiClusterCntTitle: "Clustering Cnt",
      ssiTargetFreqNumTitle: "Tartget_Freq_Number",
      ssiXTitle: "SSI_X",
      ssiAxisTitle: "SSI_Axis",
      ssiFreUpperBndTitle: "Freq_UpperBnd",
      ssiFreLowerBndTitle: "Freq_LowerBnd",

      rdTitle: "기준 감쇠비",
      rdMmTitle: "추정  감쇠비 허용 오차(%)",
      rmfTitle: "기준 고유진동수 (Hz)",
      rmfMmTitle: "추정 고유진동수 허용 오차(%)",
      slTitle: "교량 경간 길이(m)",

      clusteringCntTitle: "Clustering Cnt",
    };
  },
  created() {
    this.rd = this.bridgeData.rd;
    this.rdMm = this.bridgeData.rdMm;
    this.rmf = this.bridgeData.rmf;
    this.rmfMm = this.bridgeData.rmfMm;
    this.sl = this.bridgeData.sl;
    this.ssiFs = this.bridgeData.ssiFs;
    this.ssiMaxrow = this.bridgeData.ssiMaxrow;
    this.ssiStablevel = this.bridgeData.ssiStablevel;
    this.ssiOrder = this.bridgeData.ssiOrder;
    this.ssiOrders = this.bridgeData.ssiOrders;
    this.ssiStabfreq = this.bridgeData.ssiStabfreq;
    this.ssiDamping = this.bridgeData.ssiDamping;
    this.ssiMac = this.bridgeData.ssiMac;
    this.ssiModescale = this.bridgeData.ssiModescale;
    this.ssiProbthr = this.bridgeData.ssiProbthr;
    this.ssiScalingxi = this.bridgeData.ssiScalingxi;
    this.ssiScalingmac = this.bridgeData.ssiScalingmac;
    this.ssiOmegan = this.bridgeData.ssiOmegan;
    this.clusteringCnt = this.bridgeData.clusteringCnt;
    this.ssiTargetFreqNum = this.bridgeData.ssiTargetFreqNum;
    this.ssiX = this.bridgeData.ssiX;
    this.ssiAxis = this.bridgeData.ssiAxis;
    this.ssiFreUpperBnd = this.bridgeData.ssiFreUpperBnd;
    this.ssiFreLowerBnd = this.bridgeData.ssiFreLowerBnd;

    this.fftavgPeakCnt = this.bridgeData.fftavgPeakCnt;
    this.fftavgFreqRangeStart = this.bridgeData.fftavgFreqRangeStart;
    this.fftavgFreqRangeEnd = this.bridgeData.fftavgFreqRangeEnd;
    this.fftavgClusterCnt = this.bridgeData.fftavgClusterCnt;
    this.fftavgNumOfData = this.bridgeData.fftavgNumOfData;
    this.fftavgOverlap = this.bridgeData.fftavgOverlap;

    this.ssiFreqRangeStart = this.bridgeData.ssiFreqRangeStart;
    this.ssiFreqRangeEnd = this.bridgeData.ssiFreqRangeEnd;
    this.ssiClusterCnt = this.bridgeData.ssiClusterCnt;
  },
  beforeMount() {},
  mounted() {},
  destroyed() {},
  methods: {
    ...mapMutations(["setAlertTitle", "setConfirmTitle"]),
    insertBridgeInfo() {
      if (!this.isNumeric(this.rd)) {
        this.showNumericErrorMessage(this.rdTitle);
        return;
      }
      if (!this.isNumeric(this.rdMm)) {
        this.showNumericErrorMessage(this.rdMmTitle);
        return;
      }
      if (!this.isNumeric(this.rmf)) {
        this.showNumericErrorMessage(this.rmfTitle);
        return;
      }
      if (!this.isNumeric(this.rmfMm)) {
        this.showNumericErrorMessage(this.rmfMmTitle);
        return;
      }
      if (!this.isNumeric(this.sl)) {
        this.showNumericErrorMessage(this.slTitle);
        return;
      }
      if (!this.isNumeric(this.ssiFs)) {
        this.showNumericErrorMessage(this.ssiFsTitle);
        return;
      }
      if (!this.isNumeric(this.ssiMaxrow)) {
        this.showNumericErrorMessage(this.ssiMaxrowTitle);
        return;
      }
      if (!this.isNumeric(this.ssiStablevel)) {
        this.showNumericErrorMessage(this.ssiStablevelTitle);
        return;
      }
      if (!this.isNumeric(this.ssiOrders)) {
        this.showNumericErrorMessage(this.ssiOrdersTitle);
        return;
      }
      if (!this.isNumeric(this.ssiOrder)) {
        this.showNumericErrorMessage(this.ssiOrderTitle);
        return;
      }
      if (!this.isNumeric(this.ssiStabfreq)) {
        this.showNumericErrorMessage(this.ssiStabfreqTitle);
        return;
      }
      if (!this.isNumeric(this.ssiDamping)) {
        this.showNumericErrorMessage(this.ssiDampingTitle);
        return;
      }
      if (!this.isNumeric(this.ssiMac)) {
        this.showNumericErrorMessage(this.ssiMacTitle);
        return;
      }
      if (!this.isNumeric(this.ssiModescale)) {
        this.showNumericErrorMessage(this.ssiModescaleTitle);
        return;
      }
      if (!this.isNumeric(this.ssiProbthr)) {
        this.showNumericErrorMessage(this.ssiProbthrTitle);
        return;
      }
      if (!this.isNumeric(this.ssiScalingxi)) {
        this.showNumericErrorMessage(this.ssiScalingxiTitle);
        return;
      }
      if (!this.isNumeric(this.ssiScalingmac)) {
        this.showNumericErrorMessage(this.ssiScalingmacTitle);
        return;
      }
      if (!this.isNumeric(this.ssiOmegan)) {
        this.showNumericErrorMessage(this.ssiOmeganTitle);
        return;
      }
      if (!this.isNumeric(this.clusteringCnt)) {
        this.showNumericErrorMessage(this.clusteringCntTitle);
        return;
      }

      if (!this.isNumeric(this.fftavgPeakCnt)) {
        this.showNumericErrorMessage(this.fftavgPeakCnt);
        return;
      }
      if (!this.isNumeric(this.fftavgFreqRangeStart)) {
        this.showNumericErrorMessage(this.fftavgFreqRangeStart);
        return;
      }
      if (!this.isNumeric(this.fftavgFreqRangeEnd)) {
        this.showNumericErrorMessage(this.fftavgFreqRangeEnd);
        return;
      }
      if (!this.isNumeric(this.fftavgClusterCnt)) {
        this.showNumericErrorMessage(this.fftavgClusterCnt);
        return;
      }
      if (!this.isNumeric(this.fftavgNumOfData)) {
        this.showNumericErrorMessage(this.fftavgNumOfData);
        return;
      }
      if (!this.isNumeric(this.fftavgOverlap)) {
        this.showNumericErrorMessage(this.fftavgOverlap);
        return;
      }

      if (!this.isNumeric(this.ssiFreqRangeStart)) {
        this.showNumericErrorMessage(this.ssiFreqRangeStart);
        return;
      }
      if (!this.isNumeric(this.ssiFreqRangeEnd)) {
        this.showNumericErrorMessage(this.ssiFreqRangeEnd);
        return;
      }
      if (!this.isNumeric(this.ssiClusterCnt)) {
        this.showNumericErrorMessage(this.ssiClusterCnt);
        return;
      }

      var reqBody = {
        stid: this.stid,
        rd: this.rd,
        rdMm: this.rdMm,
        rmf: this.rmf,
        rmfMm: this.rmfMm,
        sl: this.sl,
        ssiFs: this.ssiFs,
        ssiMaxrow: this.ssiMaxrow,
        ssiStablevel: this.ssiStablevel,
        ssiOrders: this.ssiOrders,
        ssiOrder: this.ssiOrder,
        ssiStabfreq: this.ssiStabfreq,
        ssiDamping: this.ssiDamping,
        ssiMac: this.ssiMac,
        ssiModescale: this.ssiModescale,
        ssiProbthr: this.ssiProbthr,
        ssiScalingxi: this.ssiScalingxi,
        ssiScalingmac: this.ssiScalingmac,
        ssiOmegan: this.ssiOmegan,
        clusteringCnt: this.clusteringCnt,
        fftavgPeakCnt: this.fftavgPeakCnt,
        fftavgFreqRangeStart: this.fftavgFreqRangeStart,
        fftavgFreqRangeEnd: this.fftavgFreqRangeEnd,
        fftavgClusterCnt: this.fftavgClusterCnt,
        fftavgNumOfData: this.fftavgNumOfData,
        fftavgOverlap: this.fftavgOverlap,
        ssiFreqRangeStart: this.ssiFreqRangeStart,
        ssiFreqRangeEnd: this.ssiFreqRangeEnd,
        ssiClusterCnt: this.ssiClusterCnt,
        ssiTargetFreqNum: this.ssiTargetFreqNum,
        ssiFreUpperbnd: this.ssiFreUpperBnd,
        ssiFreLowerbnd: this.ssiFreLowerBnd,
        ssiX: this.ssiX,
        ssiAxis: this.ssiAxis,
      };
      this.$http
        .post("/analysisHistory/updateBridgeInfo", reqBody)
        .then((res) => {
          if (res.data.resultyn === "Y") {
            this.setAlertTitle("변경 완료");
            this.$bvModal
              .msgBoxOk("분석 설정이 변경되었습니다.", this.getAlertOptions)
              .then((value) => {
                this.$emit("setBridgeInfo");
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            this.setAlertTitle();
            this.$bvModal
              .msgBoxOk("관리자에게 문의하세요.", this.getAlertOptions)
              .then((value) => {})
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    refreshData() {
      this.rd = this.bridgeData.rd;
      this.rdMm = this.bridgeData.rdMm;
      this.rmf = this.bridgeData.rmf;
      this.rmfMm = this.bridgeData.rmfMm;
      this.sl = this.bridgeData.sl;
      this.ssiFs = this.bridgeData.ssiFs;
      this.ssiMaxrow = this.bridgeData.ssiMaxrow;
      this.ssiStablevel = this.bridgeData.ssiStablevel;
      this.ssiOrders = this.bridgeData.ssiOrders;
      this.ssiOrder = this.bridgeData.ssiOrder;
      this.ssiStabfreq = this.bridgeData.ssiStabfreq;
      this.ssiDamping = this.bridgeData.ssiDamping;
      this.ssiMac = this.bridgeData.ssiMac;
      this.ssiModescale = this.bridgeData.ssiModescale;
      this.ssiProbthr = this.bridgeData.ssiProbthr;
      this.ssiScalingxi = this.bridgeData.ssiScalingxi;
      this.ssiScalingmac = this.bridgeData.ssiScalingmac;
      this.ssiOmegan = this.bridgeData.ssiOmegan;
      this.clusteringCnt = this.bridgeData.clusteringCnt;

      this.fftavgPeakCount = this.bridgeData.fftavgPeakCount;
      this.fftavgFreqRangeStart = this.bridgeData.fftavgFreqRangeStart;
      this.fftavgFreqRangeEnd = this.bridgeData.fftavgFreqRangeEnd;
      this.fftavgClusterCnt = this.bridgeData.fftavgClusterCnt;
      this.fftavgNumOfData = this.bridgeData.fftavgNumOfData;
      this.fftavgOverlap = this.bridgeData.fftavgOverlap;

      this.ssiFreqRangeStart = this.bridgeData.ssiFreqRangeStart;
      this.ssiFreqRangeEnd = this.bridgeData.ssiFreqRangeEnd;
      this.ssiClusterCnt = this.bridgeData.ssiClusterCnt;
    },
    isNumeric(num) {
      num = String(num).replace(/^\s+|\s+$/g, "");
      var regex =
        /^[+\\-]?(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+){1}(\.[0-9]+)?$/g;
      if (regex.test(num)) {
        num = num.replace(/,/g, "");
        if (isNaN(num)) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    showNumericErrorMessage(title) {
      this.setAlertTitle();
      this.$bvModal
        .msgBoxOk(title + " 값을 확인해주세요.", this.getAlertOptions)
        .then((value) => {})
        .catch((err) => {
          console.error(err);
        });
    },
    closeModal() {
      this.$bvModal.hide("analysisHistoryModal");
    },
  },
};
</script>

<style lang="scss">
#analysisHistoryModal .modal-dialog {
  max-width: 1300px;
  & .modal-content {
    & .card {
      padding: 0 30px 30px;
      & .card-body {
        border: 1px solid #7367f0;
        border-radius: 8px;
        & .row .col {
          & label {
            display: flex;
            align-items: center;
            height: 100%;
            padding-bottom: 1px;
            width: auto;
            margin: 0 15px;
            &.head {
              width: 210px;
              margin: 0 10px 0 0;
            }
          }
          & input,
          & select {
            width: 170px;
            margin-right: 15px;
          }
        }
        &.grpHd {
          &::before {
            display: block;
            position: absolute;
            top: -15px;
            left: 50px;
            font-size: 16px;
            font-weight: 600;
            border: 1px solid #7367f0;
            border-radius: 10px;
            color: #b4b7bd;
            background: #283046;
            padding: 1px 10px 3px;
            letter-spacing: 1px;
          }
        }
      }
      &:first-child {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/analysis-history/AnalysisHistoryModal.vue